import get from 'lodash/get';
import { select, take } from 'redux-saga/effects';

import * as StatsConstants from '../../constants';
import * as D from '../../deps';
import * as TTMSelectors from '../../selectors';
import * as StatsUtils from '../../utils';

import * as StatsWorkers from './index';

export function* bufferingStart(action) {
  const ttmEvents = yield select(TTMSelectors.selectTTMEvents);
  if (ttmEvents.size > 0) {
    yield take(StatsConstants.StatsActions.BUFFERING_STOP);
    if (
      D.Utils.Time.doesMarkExist(D.Constants.App.PlaybackMarks.BUFFERING_START) &&
      D.Utils.Time.doesMarkExist(D.Constants.App.PlaybackMarks.BUFFERING_STOP)
    ) {
      D.Utils.Time.recordTimeAtMomentByMarkers(
        D.Constants.App.PlaybackMeasures.BUFFERING_TIME,
        D.Constants.App.PlaybackMarks.BUFFERING_START,
        D.Constants.App.PlaybackMarks.BUFFERING_STOP,
      );
      const bufferingTime = get(
        window.performance.getEntriesByName(D.Constants.App.PlaybackMeasures.BUFFERING_TIME),
        '[0].duration',
        null,
      );
      if (bufferingTime) {
        // action and audioType are identical to that of ttm events
        const events = ttmEvents.reduce((acc, event) => {
          acc.push(
            StatsUtils.createBufferingStatsObject(bufferingTime, event.ttmAction, event.audioType),
          );
          return acc;
        }, []);
        yield StatsWorkers.logBufferingEvents(events);
      }
    }
  }
}
